import React from 'react';

import { Card, CardContent } from '@mui/material';
import Icon from 'screens/shared/icon';
import Loader from 'screens/shared/loader';

export default ({
  onClick = null, children, className = '', isArrow = true, isLoader = false,
}) => (
  <Card className={`cards-item ${className}`} onClick={onClick || null}>
    <CardContent className="cards-item-content">
      <div className="body">
        {children}
      </div>

      {!!onClick && isArrow && !isLoader && (
        <div className="cards-item-arrow">
          <Icon name="chevron-right" />
        </div>
      )}

      {isLoader && (
        <div className="cards-item-arrow" style={{ marginRight: 10 }}>
          <Loader isInline show size={25} />
        </div>
      )}
    </CardContent>
  </Card>
);
